import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { AuthProvider } from './context/AuthContext';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { AuthPage } from './pages/AuthPage';
import { HomePage } from './pages/HomePage';
import { MovieDetailPage } from './pages/MovieDetailPage';
import { PaymentSuccessPage } from './pages/PaymentSuccessPage';
import { PlaybackPage } from './pages/PlaybackPage';
import { RentalsPage } from './pages/RentalsPage';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/signup" element={<AuthPage mode="signup" />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/movies/:id" element={<MovieDetailPage />} />
            <Route path="/watch/:id" element={<PlaybackPage />} />
            <Route path="/rentals" element={<RentalsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
